module.exports = __webpack_public_path__ + "img/user_wumpus.cf20a91d.png";